<div class="property-data-container dynamic-fields-section py-2">
	<div class="container">
		<div class="row form-section mb-0" *ngIf="title">
			<div class="col">
				<h5 class="section-title mb-0">{{title}}</h5>
			</div>
		</div>
		<div class="row" *ngFor="let row of rows">
			<div class="col" *ngFor="let col of row">
				<cv-schema-render-form-field
					[options]="{
						path: col.path,
						label:'AI provided Condition Rating',
						displayType:'PublicRecord',
						editable: false
					}"
					[indexTab]="1">
				</cv-schema-render-form-field>
			</div>
		</div>
	</div>
</div>
